import WorkForce from "../../views/WorkForce";

const WorkForcePage = () => {
  return <WorkForce />;
};

export default WorkForcePage;
